import { useDispatch, useSelector } from "react-redux";

import { updateBalance } from "src/redux/slices/other/balance-slice";
import { getCurrentContractAddresses } from "src/web3/address";
import ERC20MockContract from "src/web3/utils/ERC20MockContract";

function useTravaBalance() {
  const accountAddress = useSelector((state) => state.accountSlice.address);
  const travaBalance = useSelector((state) => state.balanceSlice.travaBalance);
  const dp = useDispatch();

  async function fetchTravaBalance() {
    try {
      const { TRAVA_TOKEN_ADDRESS } = getCurrentContractAddresses();
      const contract = ERC20MockContract.getContractFactory(TRAVA_TOKEN_ADDRESS, { decimals: 18 });
      const balanceBN = await contract.getBalance(accountAddress);
      dp(updateBalance({ travaBalance: balanceBN.toNumber() }));
    } catch (error) {
      console.error(error);
      dp(updateBalance({ travaBalance: null }));
    }
  }

  async function updateTravaBalance() {
    await fetchTravaBalance();
  }

  return { travaBalance, fetchTravaBalance, updateTravaBalance };
}

export default useTravaBalance;
